import React, { useState } from "react";
import Footer from "../Footer";
import NavBar from "../NavBar";
import ExploreAppsTop from "./ExploreAppsTop";
import ExploreAppsList from "./ExploreAppsList";
import { ScrollRestoration } from "react-router-dom";

import { analytics } from "../../App";
import { logEvent } from "firebase/analytics";
import { BASE_URL } from "../Config";
import ExploreAppsSearchBar from "./ExploreAppsSearchBar";
import { appListItems } from "./AppList";
import { PageContext } from "../../App";

function ExploreAppsMain() {
  //app list showing
  const [appListShowing, setAppListShowing] = useState(appListItems);

  return (
    <PageContext.Provider
      value={{
        appListShowing,
        setAppListShowing,
      }}
    >
      <div>
        {/* Scroll to top */}
        <ScrollRestoration />
        {/* Log event */}
        {/*Firebase analytics */}
        {logEvent(analytics, "Explore Apps")}

        {/*Add title and metadata */}
        <title>PDF & Image Editing Tools Online Free</title>
        <meta name="robots" content="index, follow"></meta>
        <link rel="canonical" href={`${BASE_URL}/explore_apps`} />
        <meta
          name="description"
          content="All in one PDF manager and image editing tools. Edit, convert, compress, merge PDFs and enhance images easily with our fast, secure online tools."
        ></meta>
        <meta
          name="keywords"
          content="pdf manager, pdf tools, pdf editing tools, online pdf editor, pdf converter, compress pdf, merge pdf, split pdf, rearrange pdf, rotate pdf, crop pdf, resize pdf, lock pdf, unlock pdf, watermark pdf, pdf ocr, pdf translator, pdf summarizer, pdf viewer, pdf annotator, pdf repair, image editing tools, image editor online, image converter, image resizer, crop image, resize image, rotate image, flip image, merge images, split image, watermark images, upscale image, html to image, online image tools, free pdf tools, all in one pdf tool,"
        ></meta>

        {/** Scroll to top */}
        <ScrollRestoration />
        {/* Nav Bar */}
        <NavBar />
        {/* Exlore Apps Top */}
        <ExploreAppsTop />
        {/* Explore app search bar */}
        <ExploreAppsSearchBar />
        {/* App List Grid */}
        <ExploreAppsList />
        {/* Footer */}
        <Footer />
      </div>
    </PageContext.Provider>
  );
}

export default ExploreAppsMain;
